import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'acceptButton'
	| 'acceptAllButton'
	| 'rejectButton'
	| 'actionCardTitle'
	| 'descriptionTitle'
	| 'nameTitle'
	| 'behaviorTitle'
	| 'conversationStartersTitle'
	| 'scenariosTitleLegacy'
	| 'scenariosTitle'
	| 'agentPlanCardSubtitle'
	| 'removeFieldDescription'
	| 'instructionsTitle'
	| 'isDeepResearchEnabledTitle'
	| 'isWebSearchEnabledTitle'
	| 'knowledgeSourcesTitle'
	| 'agenticSkillsTitle'
	| 'toolsTitleLegacy'
	| 'toolsTitle'
	| 'enabledValue'
	| 'disabledValue'
	| 'allOrganisationalKnowledge'
	| 'noOrganisationalKnowledge';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		acceptButton: {
			id: 'ai-mate.studio-update-agent.agent-diff.accept-button',
			defaultMessage: 'Accept',
			description: 'Text for the accept button in the agent diff card',
		},
		acceptAllButton: {
			id: 'ai-mate.studio-update-agent.agent-diff.accept-all-button',
			defaultMessage: 'Accept all',
			description: 'Text for the accept all button',
		},
		rejectButton: {
			id: 'ai-mate.studio-update-agent.agent-diff.reject-button',
			defaultMessage: 'Reject',
			description: 'Text for the reject button in the agent diff card',
		},
		actionCardTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card-title',
			defaultMessage: 'Plan update',
			description: 'Title for the action card in the agent diff view',
		},
		descriptionTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.description.title',
			defaultMessage: 'Description',
			description: 'Title for the description field',
		},
		nameTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.name.title',
			defaultMessage: 'Name',
			description: 'Title for the name field in the agent diff card',
		},
		behaviorTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.behavior.title',
			defaultMessage: 'Behavior',
			description: 'Title for the behavior field in the agent diff card',
		},
		conversationStartersTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.conversation-starters.title',
			defaultMessage: 'Conversation Starters',
			description: 'Title for the conversation starters field',
		},
		scenariosTitleLegacy: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.scenarios-legacy.title',
			defaultMessage: 'Scenarios',
			description: 'Title for the scenarios field in the agent diff card',
		},
		scenariosTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.scenarios.title',
			defaultMessage: 'Subagents',
			description: 'Title for the scenarios field in the agent diff card',
		},
		agentPlanCardSubtitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.agent-plan-card-subtitle',
			defaultMessage: '{numberOfChanges} changes',
			description: 'Subtitle for the agent plan card indicating the number of changes.',
		},
		removeFieldDescription: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.remove-field-description',
			defaultMessage: 'Remove {fieldName}.',
			description: 'Description text for removing a field value.',
		},
		instructionsTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.instructions-title',
			defaultMessage: 'Instructions',
			description: 'Title for the instructions field in agent diff card',
		},
		isDeepResearchEnabledTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.deep-research-title',
			defaultMessage: 'Deep Research',
			description: 'Title for the deep research field in agent diff card',
		},
		isWebSearchEnabledTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.web-search-title',
			defaultMessage: 'Web Search',
			description: 'Title for the web search field in agent diff card',
		},
		knowledgeSourcesTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.knowledge-sources-title',
			defaultMessage: 'Knowledge',
			description: 'Title for the knowledge sources field in agent diff card',
		},
		agenticSkillsTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.agentic-skills.title',
			defaultMessage: 'Skills',
			description:
				'Title for the agentic skills field in agent diff card, shown as Skills in the UI',
		},
		toolsTitleLegacy: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.tools-legacy.title',
			defaultMessage: 'Skills',
			description: 'Title for the tools field in agent diff card',
		},
		toolsTitle: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.tools.title',
			defaultMessage: 'Tools',
			description: 'Title for the tools field in agent diff card',
		},
		enabledValue: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.enabled-value',
			defaultMessage: 'Enabled',
			description: 'Text shown when a boolean field is enabled in agent diff card',
		},
		disabledValue: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.disabled-value',
			defaultMessage: 'Disabled',
			description: 'Text shown when a boolean field is disabled in agent diff card',
		},
		allOrganisationalKnowledge: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.all-organisational-knowledge',
			defaultMessage: 'All organisational knowledge.',
			description: 'Text indicating all organisational knowledge is enabled in agent diff card',
		},
		noOrganisationalKnowledge: {
			id: 'ai-mate.studio-update-agent.agent-diff.action-card.field.no-organisational-knowledge',
			defaultMessage: 'No organisational knowledge.',
			description: 'Text indicating no organisational knowledge is enabled in agent diff card',
		},
	});

export default message;
